import api from "../../Environment";
import configuration from "react-global-configuration";

/**
 * A-009A.4 — Main navigation API.
 * React consumes only mainNavigationPayload (main_navigation[]).
 */

function settingsFallback() {
  try {
    const fromConfig = configuration.get("configData.main_navigation");
    if (fromConfig && typeof fromConfig === "object") {
      return fromConfig;
    }
  } catch (e) {
    /* ignore */
  }
  return { main_navigation: [] };
}

export async function fetchMainNavigation() {
  try {
    const response = await api.postMethod("navigation", {});
    const body = response && response.data;
    if (body && body.success === true && body.data) {
      return body.data;
    }
    // Soft-fail to settings/bootstrap nav, but flag so the header can toast (UI-016).
    return Object.assign(settingsFallback(), { loadError: true });
  } catch (e) {
    return Object.assign(settingsFallback(), { loadError: true });
  }
}

export function mainNavigationItems(payload) {
  if (!payload || typeof payload !== "object") {
    return [];
  }
  const items = payload.main_navigation;
  return Array.isArray(items) ? items : [];
}

/**
 * Appearance Engine / navigation-page presentation for a system_key page
 * (e.g. guide). Reads settings bootstrap first, then optional live nav payload.
 */
export function navigationPagePresentation(systemKey, livePayload) {
  const key = systemKey && String(systemKey);
  if (!key) return null;

  try {
    const bundle = configuration.get("configData.main_navigation");
    const pages = bundle && bundle.navigation_pages;
    if (pages && pages[key] && typeof pages[key] === "object") {
      return pages[key];
    }
  } catch (e) {
    /* ignore */
  }

  if (livePayload && livePayload.navigation_pages && livePayload.navigation_pages[key]) {
    return livePayload.navigation_pages[key];
  }

  const items = mainNavigationItems(livePayload || settingsFallback());
  for (let i = 0; i < items.length; i++) {
    if (items[i] && items[i].system_key === key) {
      return items[i];
    }
  }

  return null;
}

export function isExternalNavRoute(route) {
  if (!route || typeof route !== "string") {
    return false;
  }
  const trimmed = route.trim();
  return /^https?:\/\//i.test(trimmed) || trimmed.startsWith("//");
}
